import { useQuery } from '@apollo/client';
import { QueryResult, FETCH_EMPLOYEE_QUESTIONS } from './query';

export const useFetchQuestionGroups = () => {
  return useQuery<QueryResult>(FETCH_EMPLOYEE_QUESTIONS, {
    fetchPolicy: 'cache-and-network'
  });
};
